import React from "react";
import { ReactComponent as Frame } from "../../../../img/Frame.svg";

const PotentialGainBackground = () => {
  return <Frame />;
};
export default PotentialGainBackground;
